/**
 * @generated SignedSource<<c9a66df10aa81eab356e0b002c4f9a6e>>
 * @relayHash 0ef5cc19917504e49f6549f0d9b1f250
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eed2786afe4fa2681e7cf904a545383a0ec1cad73881ad1687ebad937874f3d1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "eed2786afe4fa2681e7cf904a545383a0ec1cad73881ad1687ebad937874f3d1",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
